// Types per turni

export enum ShiftStatus {
  Scheduled = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3,
}

export interface Shift {
  id: number;
  siteId: number;
  siteName: string;
  employeeId?: number;
  employeeName?: string;
  role: string;
  startTime: string;
  endTime: string;
  status: string;
  notes?: string;
  actualStartTime?: string;
  actualEndTime?: string;
  hoursWorked?: number;
  createdBy: number;
  createdByName: string;
  createdAt: string;
}

export interface CreateShiftRequest {
  siteId: number;
  employeeId?: number;
  role: string;
  startTime: string;
  endTime: string;
  notes?: string;
}

export interface UpdateShiftRequest {
  employeeId?: number;
  role?: string;
  startTime?: string;
  endTime?: string;
  status?: ShiftStatus;
  notes?: string;
}

export interface ShiftFilter {
  siteId?: number;
  employeeId?: number;
  startDate?: string;
  endDate?: string;
  status?: ShiftStatus;
  page?: number;
  pageSize?: number;
}

export interface PagedResponse<T> {
  success: boolean;
  data: T[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  message?: string;
}
